import { AbstractControl, FormGroupDirective } from "@angular/forms";
import { LocalStorageService } from "./../../services/shared/local-storage/local-storage.service";
import { AfterViewInit, ApplicationRef, Directive, ElementRef, HostListener, Input, NgZone, Renderer2 } from "@angular/core";

@Directive({
    selector: "[editingBorder]",
    standalone: false
})
export class EditingBorderDirective implements AfterViewInit {
  /** Valor inicial normalizado a string desde el FormControl (no del DOM) para comparar correctamente booleanos */
  initialValue: string = '';
  private userInteracted = false;

  constructor(
    private el: ElementRef<HTMLInputElement | HTMLSelectElement>,
    private formGroupDirective: FormGroupDirective,
    private localStorage: LocalStorageService,
    private renderer: Renderer2,
    private appRef: ApplicationRef,
    private ngZone: NgZone
  ) { }

  @HostListener("ngModelChange") onModelChange() {
    this.userInteracted = true;
    this.editingBorder();
  }

  //TODO: Borrar este input en la refactorizacion, solo se dejo por problema de duplicado en sonar, no se utiliza.
  @Input() valueEditing: any;

  ngAfterViewInit(): void {
    // Capturar el valor inicial desde el FormControl de Angular en lugar del DOM.
    // Esto evita el problema en Angular 21+ donde el DOM ya tiene el binding correcto
    // en ngAfterViewInit, haciendo que "true" === "true" siempre sea pristine al seleccionar true.
    const inputElement = this.el.nativeElement;
    const controlName = inputElement.getAttribute("name");
    const control: AbstractControl = this.formGroupDirective.form?.get(controlName);

    if (control) {
      // Normalizar a string igual que el DOM lo haría, para comparaciones consistentes
      this.initialValue = control.value != null ? String(control.value) : '';
    } else {
      this.initialValue = inputElement.value;
    }
    // No llamar a editingBorder() aquí para evitar NG0101 (tick recursivo).
  }

  editingBorder(): void {
    const inputElement: HTMLInputElement | HTMLSelectElement = this.el.nativeElement;
    const hasNgbDatepicker = inputElement.classList.contains("ngbDatepicker");
    const controlName = inputElement.getAttribute("name");
    const formGroup = this.formGroupDirective.form;
    const control: AbstractControl = formGroup.get(controlName);

    if (hasNgbDatepicker) {
      this.localStorage.dateBackup[controlName] = false;
    }
    if (control) {
      const currentValueStr = inputElement.value;
      const isDirty = currentValueStr !== this.initialValue;

      if (isDirty) {
        control.markAsDirty();
        this.renderer.addClass(inputElement, "editing");
        if (inputElement instanceof HTMLSelectElement)
          this.localStorage.selectDirty[controlName] = true;
      } else {
        control.markAsPristine();
        this.renderer.removeClass(inputElement, "editing");
        if (inputElement instanceof HTMLSelectElement)
          this.localStorage.selectDirty[controlName] = false;
      }
      if (hasNgbDatepicker && !inputElement.value && !this.initialValue) {
        control.markAsPristine();
        this.renderer.removeClass(inputElement, "editing");
        this.localStorage.dateBackup[controlName] = true;
      }
      // Forzar CD global solo cuando el usuario interactuó.
      // Usar setTimeout fuera de la zona Angular para evitar NG0101
      // (ApplicationRef.tick called recursively) en Angular 21+.
      if (this.userInteracted) {
        this.ngZone.runOutsideAngular(() => {
          setTimeout(() => {
            this.ngZone.run(() => {
              this.appRef.tick();
            });
          }, 0);
        });
      }
    }
  }
}
